import React, { useState } from 'react';
import SectionTitle from './SectionTitle';
import { BsPersonWorkspace } from "react-icons/bs";
import WorkComponent from './Work';

const decagonRoles = [
    "Developed and maintained multiple web applications using the MERN stack, ensuring efficient and scalable code architecture.",
    "Collaborated closely with cross-functional teams to gather and analyze project requirements, resulting in successful project deliveries.",
    "Demonstrated strong problem-solving skills by troubleshooting and resolving complex technical issues in a timely manner.",
    "Actively participated in code reviews and provided valuable feedback to team members, contributing to enhanced code quality and best practices.",
    "Successfully integrated third-party APIs, such as payment gateways and storage services, to extend application functionality."
];

const upworkRoles = [
    "Successfully completed multiple freelance projects as a junior MERN stack developer, delivering high-quality web applications within client deadlines",
    "Developed responsive and user-friendly interfaces, resulting in enhanced user experiences and increased client retention.",
    "Demonstrated strong communication skills by effectively understanding and translating client requirements into technical solutions, leading to successful project outcomes."
];

const sakemRoles = [
    "Actively contributed as a frontend developer intern, collaborating with the development team to create visually appealing and user-friendly web interfaces.",
    "Successfully implemented responsive designs, ensuring seamless user experiences across various devices and screen sizes.",
    "Assisted in the development and maintenance of front-end components, optimizing code efficiency and enhancing application performance."
];

const Experience = () => {
    const [ decagon, setDecagon ] = useState(true);
    const [ upwork, setUpwork ] = useState(false);
    const [ sakem, setSakem ] = useState(false);
    const [ splash, setSplash ] = useState(false);
    const [ amazon, setAmazon ] = useState(false);
  return (
    <section id='experience' className='max-w-containerxs mx-auto py-10 lgl:py-24 px-4'>
        <SectionTitle title='Where I have worked' emoji={<BsPersonWorkspace />} />
        <div className='w-full mt-10 flex flex-col md:flex-row gap-16'>
            <ul className='md:w-32 flex flex-col'>
                <li className={`border-l-2 ${decagon ? "border-l-textGreen text-textGreen" : "border-l-hoverColor text-textDark"} bg-transparent hover:bg-[#112240] py-3 text-sm cursor-pointer duration-300 px-8 font-medium`} onClick={()=>{
                    setDecagon(true);
                    setUpwork(false);
                    setAmazon(false);
                    setSplash(false);
                    setSakem(false);
                }}>
                    Decagon
                </li>
                <li className={`border-l-2 ${upwork ? "border-l-textGreen text-textGreen" : "border-l-hoverColor text-textDark"} bg-transparent hover:bg-[#112240] py-3 text-sm cursor-pointer duration-300 px-8 font-medium`} onClick={()=>{
                    setDecagon(false);
                    setUpwork(true);
                    setAmazon(false);
                    setSplash(false);
                    setSakem(false);
                }}>Upwork</li>
                <li className={`border-l-2 ${sakem ? "border-l-textGreen text-textGreen" : "border-l-hoverColor text-textDark"} bg-transparent hover:bg-[#112240] py-3 text-sm cursor-pointer duration-300 px-8 font-medium`} onClick={()=>{
                    setDecagon(false);
                    setUpwork(false);
                    setAmazon(false);
                    setSplash(false);
                    setSakem(true);
                }}>Sakem</li>
            </ul>
            {
                decagon ? 
                    <WorkComponent title="Full-Stack Engineer" company="Decagon Institute" timeline="Nov 2022 - Present" roles={decagonRoles} />
                : upwork ?
                    <WorkComponent title="Full-Stack Engineer" company="Upwork" timeline="Jan 2021 - Jul 2022" roles={upworkRoles} />
                :
                    <WorkComponent title="FrontEnd Engineer" company="Sakem Environmental Services Ltd" timeline="Jul 2020 - Dec 2020" roles={sakemRoles} />
                
                
            }
        </div>
    </section>
  )
}

export default Experience